import React, {Component} from 'react';
import './HomePageFooter.css';


function HomePageFooter() {

    return (
      <div className="home_footer">
        <p>2019 © Impact Planning Group LLC. 11 Grumman Hill Rd, Wilton, CT 06897. 203-854-1011</p>
      </div>
    )
  
}

export default (HomePageFooter);



// WEBPACK FOOTER //
// ./src/components/Home/HomePageFooter/HomePageFooter.jsx